export default "__VITE_ASSET__eXFW45jl__"